import { getSharedApiClient } from "@/shared-utils";

import type { TrainingAnalyticRequest } from "./models";

export async function sendTrainingAnalytic(request: TrainingAnalyticRequest) {
    return await getSharedApiClient()
        .extend(({ prefix }) => ({ prefix: `${prefix}/api/training` }))
        .post("publish-training-analytics", { json: request });
}
